export default __webpack_public_path__ + "static/media/Hero 44.f3f13a14.jpg";